<div class="contextmenu" [ngStyle]="{'left.px': x, 'top.px': y}">
    <ul class="popup-menu-items">
        <li class="popup-menu-item"><a class="item-edit" (click)="menuItemClick($event)">Edit</a></li>
        <li class="popup-menu-item"><a class="item-delete" (click)="menuItemClick($event)">Delete</a></li>
    </ul>
</div>